// frontend/src/routes/TeacherRoute.jsx
import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { getMe } from '../services/authService'

export default function TeacherRoute({ children }) {
  const [role, setRole] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) {
      setRole(null)
      setLoading(false)
      return
    }
    getMe()
      .then((user) => {
        setRole(user.role)      // 取得した role を state にセット
      })
      .catch(() => {
        setRole(null)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    // 読み込み中は何も描画しない or スピナーを出しても OK
    return null
  }

  // ← ここを変更！ teacher または admin なら通す
  if (role === 'teacher' || role === 'admin') {
    return children
  }

  // それ以外はログイン画面へリダイレクト
  return <Navigate to="/login" replace />
}